import { service } from '../axios';
export function getWaitApprovalTaskHome() {
    return service({
        url: '/home/getWaitApprovalTask',
        method: 'get'
    });
}
export function getInspectionStatistics() {
    return service({
        url: '/home/getInspectionStatistics',
        method: 'get'
    });
}
export function getAuditLists() {
    return service({
        url: '/home/getAuditLists',
        method: 'get'
    });
}
export function getLabStatistics() {
    return service({
        url: '/home/getLabStatistics',
        method: 'get'
    });
}
export function getLabRiskExpireWarning() {
    return service({
        url: '/home/getLabRiskExpireWarning',
        method: 'get'
    });
}
